// l10n status: done
import { action, override, observable, makeObservable } from "mobx"
import { PlayerTrackAbstract, PlayerTrackAbstractItem } from "store/page/player/PlayerAbstract"
import { languageName, countryName} from "utils/IntlManager"
import { rootStore } from "store/RootStore"
import { isMobileScreenSize } from "utils/Utils"
import { l10n } from "store/lang/L10n"

class PlayerTrackAudioItemVjs extends PlayerTrackAbstractItem {
	//id = null // in base class
	lang = null
	name = null
	type = null

	constructor(parent, path) {
		super(parent, path)
		makeObservable(this, {
			// MTV-3583: do not make it observable here, mobx 6 generates an error if it's already registered in the base class
			//id: observable,
			lang: observable,
			name: observable,
			type: observable,
			setTrack: action
		})
	}

	get labelText() {
		return this.name
	}

	setTrack() {
		if (!this.id) this.id = ""
		console.debug("SETTRACK AUDIO id", this.id, this.parent)
		if (this.player.isStreamLoaded) {
			this.parent.setCurrent(this.id)
			//this.player._api?.selectAudioTrack(this.id)
			const _tracks = this.player._api?.audioTracks()
			for (let i = 0; i < _tracks?.length; i++) {
				if (_tracks[i].enabled) _tracks[i].enabled = false
				if (_tracks[i].id === this.id) _tracks[i].enabled = true
			}
		}
		return this
	}
}

export class PlayerTrackSubtitleItemVjs extends PlayerTrackAbstractItem {
	//id = null // in base class
	kind = null
	label = null
	lang = null

	constructor(parent, path) {
		super(parent, path)
		makeObservable(this, {
			// MTV-3583: do not make it observable here, mobx 6 generates an error if it's already registered in the base class
			//id: observable,
			kind: observable,
			label: observable,
			lang: observable,
			setTrack: action
		})
	}

	get labelText() {
		return this.label
	}

	// iOS native tracks have an empty id, id is readonlyy property on original tracks!
	fixTrackId(track) {
		return (!track.id || track.id === "") ? track.language : track.id
	}

	setTrack() {
		//this.player.setSelectSubtitleTrack(this.id !== this.parent.current?.id ? this.id : null)
		console.debug("SETTRACK SUBTITLE id %s, %s, %o", this.id, this.parent.current?.id, this.parent)
		try {
			// iOS does not work when using remoteTextTracks
			//const _tracks = this.player._api?.remoteTextTracks()
			const _tracks = this.player._api?.textTracks()
			this.parent.setCurrent("")
			for (let i = 0; i < _tracks?.length; i++) {
				if (this.fixTrackId(_tracks[i]) === this.id) {
					console.debug("ENABLE", this.id)
					_tracks[i].default = true
					_tracks[i].mode = "showing"
					this.parent.setCurrent(this.id)
				}
				else {
					_tracks[i].default = false
					_tracks[i].mode = "disabled"
				}
			}
			// MTVW-764
			this.player.clearSubtitles()
			// persist selection
			rootStore.sso.browserStore.setSubTitle(this.parent.current?.lang)
			console.debug("SETTRACK SUB %o", this.id, this.parent.current?.lang, _tracks)
		}
		catch (e) {
			console.error("setTrack", e)
		}
		return this
	}
}

class PlayerTrackAbstractVjs extends PlayerTrackAbstract {
	constructor(parent, path) {
		super(parent, path)
		makeObservable(this, {
			// change for mobx 6.3 which is more strict
			//setTracks: action
			setTracks: override
		})
	}

	get _getTrackItem() {
		return PlayerTrackAbstractItem
	}

	_translate(item) {
		let translated = languageName(item?.lang)
		// languageName would return German "Aus" as "aus"
		// MTVW-1100: IntlManager.languageName returns undefined for mis, mul, und, zxx, qaa, qad etc.
		if (item?.lang === l10n.audiotrackNone || !translated) translated = item?.lang
		//console.debug("translated %s, %s, %o", translated, translated?.length, item)
		if (translated) {
			/*
			if (translated.toLowerCase() === "mis") translated = "Andere" //"Einzelne andere Sprachen"
			if (translated.toLowerCase() === "mul") translated = "Mehrere" //"Mehrere Sprachen"
			*/
			const isoTable = [
				{ iso: "mis", text: l10n.audiotrackMis },
				{ iso: "mul", text: l10n.audiotrackMul },
				{ iso: "nar", text: l10n.audiotrackNar },
				{ iso: "none", text: l10n.audiotrackNone },
				{ iso: "qaa", text: l10n.audiotrackQaa },
				{ iso: "qad", text: l10n.audiotrackQad },
				{ iso: "und", text: l10n.audiotrackUnd },
				{ iso: "zxx", text: l10n.audiotrackZxx },
				// MTVW-643: new entries
				{ iso: "pil", text: l10n.audiotrackPil },
				{ iso: "qks", text: l10n.audiotrackQks },
				{ iso: "qpi", text: l10n.audiotrackQpi },
				{ iso: "qsu", text: l10n.audiotrackQsu },
				{ iso: "sun", text: l10n.audiotrackSun }
			]
			const found = isoTable.find(element => element.iso === translated.toLowerCase())
			//console.debug("found", translated, found)
			if (found) translated = found.text
		}
		if (item?.name) {
			// audio track
			item.name = translated
			// iOS: empty if no information available
			if (item.name === "") {
				item.name = l10n.audiotrackUnd
				item.id = ""
			}
		} else if (item?.label) {
			// subtitle track
			// for captions, currently disabled
			const result = item.label.split(/\s+/).slice(1)
			item.label = translated + " " + result.join(" ")
		}
		return item
	}

	setTracks(tTrack = null, current = null) {
		this.tTrack = tTrack === null ? [] : tTrack
		if (!this.tTrack?.length) {
			this.current = void 0
		}
		else {
			this.tTrack?.forEach(i => {
				this._translate(i)
			})
		}
		if (current) this.current = current
		return this
	}
}

export class PlayerTracksAudioVjs extends PlayerTrackAbstractVjs {
	constructor(parent, path) {
		super(parent, path)
		makeObservable(this, {
			// change for mobx 6.3 which is more strict
			//setTracksFromStream: action
			setTracksFromStream: override
		})
	}

	get _getTrackItem() {
		return PlayerTrackAudioItemVjs
	}

	setTracksFromStream() {
		console.info("@()")
		// MTVW-616: try/catch
		try {
			const api = this.player._api
			if (!api) return
			let _tracks = api.audioTracks()
			console.debug("setTracksFromStream audiotracks", _tracks?.length, _tracks, _tracks.tracks_?.length, _tracks.tracks_)
			// convert to regular array for compatibility with exisiting library functions
			//let current = api.getCurrentAudioTrack()?.id
			let current = ''
			const tracks = []
			for (let i = 0; i < _tracks?.length; i++) {
				tracks.push({ lang: _tracks[i].language, name: _tracks[i].label, id: _tracks[i].id, type: "AUDIO" })
				if (_tracks[i].enabled) current = tracks[i]
				/*
				VJS   loaded_: true
						enabled: true
						id: "German"
						kind: "main"
						label: "German"
						language: "de"
	
				VO    groupId: "audio-aacl-88"         groupId: "audio-aacl-88"
						id: "7"                          id: "6"
						lang: "mis"                      lang: "de"
						name: "Uncoded languages"        name: "German"
						type: "AUDIO"                    type: "AUDIO"
				*/
			}
			if (tracks?.length === 0) {
				// Insert item in case there is no information
				current = ""
				tracks.unshift({ id: "", type: "AUDIO", name: l10n.audiotrackUnd, lang: l10n.audiotrackUnd })
			}
			if (!current) current = ""
			this.setTracks(tracks, current)
			console.debug("AUDIO TRACKS %o, %o, current %o", api.audioTracks(), this.tTrack, this.current)
		}
		catch (err) {
			console.error("CAUGHT in subtitles setTracksFromStream", err)
		}
		return this
	}
}

export class PlayerTracksSubtitleVjs extends PlayerTrackAbstractVjs {
	constructor(parent, path) {
		super(parent, path)
		makeObservable(this, {
			// change for mobx 6.3 which is more strict
			//setTracksFromStream: action
			setTracksFromStream: override
		})
	}

	get _getTrackItem() {
		return PlayerTrackSubtitleItemVjs
	}

	_setSubtitleStyles() {
		return
		const api = this.player._api
		//const subtitleStyles = api.getDefaultSubtitleStyles()
		const subtitleStyles = {}
		console.debug("getDefaultSubtitleStyles", api.getDefaultSubtitleStyles())
		// MTVW-92: disable default text "FCC subtitle sample" at play start, doesn't work with an empty string or null. voCaptionParserPlugin instead doesn't need to be added!
		subtitleStyles.previewSubtitleText = ""
		// setting fo false disables the above mentioned text, and also removes the box with opacity when 2 lines are displayed
		// below settings do not work if enable is set to false
		subtitleStyles.enable = true
		// ???
		//subtitleStyles.enableAutoAdjustment = false
		subtitleStyles.fontFamily = { enable: true, value: "EuropaRegular" }
		// no noticeable effect
		subtitleStyles.boundingBox = { enable: true, value: { bottom: "82%", left: "10%", right: "84%", top: "80%" } }
		subtitleStyles.fontBackgroundColor = { enable: false, value: "black" }
		/*
		subtitleStyles.fontBackgroundColor = { enable: true, value: "black" }
		subtitleStyles.fontBackgroundOpacity = { enable: true, value: 1.0 }
		subtitleStyles.fontOpacity = { enable: true, value: 1.0 }
		*/
		// font size has no impact on Safari
		let fontSize = isMobileScreenSize() ? "200%" : "400%"
		// would require dynamic orientation handling
		if ((window.innerHeight > window.innerWidth) && isMobileScreenSize()) fontSize = "150%" // portrait on mobile
		subtitleStyles.fontSize = { enable: true, value: fontSize }
		//subtitleStyles.windowColor = { enable: true, value: "black" }
		//subtitleStyles.windowOpacity = { enable: true, value: 0.25 }
		//subtitleStyles.fontEdgeColor = { enable: true, value: "blue" }
		//subtitleStyles.fontVertPosition = { enable: true, value: "top" }
		api.setSubtitleStyles(subtitleStyles)
		//console.debug("setting %o", subtitleStyles)
		console.debug("getDefaultSubtitleStyles", api.getDefaultSubtitleStyles())
	}

	_getSelectedTrackId(tracks) {
		// select persisted language if available, otherwise subtitles will be switched off
		const persistedLanguage = rootStore.sso.browserStore.getSubTitle()
		const selectedTrack = tracks.filter(i => i.lang === persistedLanguage)
		let id = ""
		if (selectedTrack?.length === 1) id = selectedTrack[0].id
		return id
	}

	// iOS native tracks have an empty id, id is readonlyy property on original tracks!
	fixTrackId(track) {
		return (!track.id || track.id === "") ? track.language : track.id
	}

	adjustTracks(_tracks) {
		// convert to regular array for compatibility with exisiting library functions
		let tracks = []
		for (let i = 0; i < _tracks?.length; i++) {
			// iOS native tracks have an empty id, id is readonlyy property on original tracks!
			tracks.push({ id: this.fixTrackId(_tracks[i]), kind: _tracks[i].kind, label: _tracks[i].label, lang: _tracks[i].language, mode: _tracks[i].mode, default: _tracks[i].default })
			/*
			VJS   default: undefined                  default: true
					id: "vjs_track_147"                 id: "German"
					kind: "metadata"                    kind: "subtitles"
					label: "segment-metadata"           label: "German"
					language: ""                        language: "de"
					mode: "hidden"                      mode: "disabled"
		
			VO    id: "0"
					kind: "subtitles"
					label: "German"
					lang: "de"
			*/
		}
		// remove entries with "caption"
		tracks = tracks.filter(i => i.label.toLowerCase().indexOf("caption") < 0)
		tracks = tracks.filter(i => i.kind !== "caption")
		tracks = tracks.filter(i => i.kind !== "metadata")
		// insert and mark SUBTITLE_OFF item with empty id
		tracks.unshift({ id: "", kind: "subtitles", label: l10n.audiotrackNone, lang: l10n.audiotrackNone })
		return tracks
	}

	setTracksFromStream() {
		// MTVW-616: try/catch
		try {
			const api = this.player._api
			if (!api) return
			// iOS does not work when using remoteTextTracks
			//let _tracks = api.remoteTextTracks()
			let _tracks = api.textTracks()
			console.debug("setTracksFromStream texttracks", _tracks)
			// convert to regular array for compatibility with exisiting library 
			const tracks = this.adjustTracks(_tracks)
			// now define and apply selected subtitle
			const id = this._getSelectedTrackId(tracks)
			//this.player.setSelectSubtitleTrack(id)

			for (let i = 0; i < _tracks?.length; i++) {
				// id !== "": potenial fix for subitles occasionally displayed although they are switched off
				if (id !== "" && this.fixTrackId(_tracks[i]) === id) {
					console.debug("ENABLE", id)
					_tracks[i].default = true
					_tracks[i].mode = "showing"
				}
				else {
					_tracks[i].default = false
					_tracks[i].mode = "disabled"
				}
			}

			this.setTracks(tracks, id)
			console.debug("SUBTITLE TRACKS %o, %o, current %o", id, _tracks, tracks, this.tTrack, this.current)

			this._setSubtitleStyles()
		}
		catch (err) {
			console.error("CAUGHT in subtitles setTracksFromStream", err)
		}
		return this
	}
}
